import { render, staticRenderFns } from "./role_edit.vue?vue&type=template&id=12a65f16&"
import script from "./role_edit.vue?vue&type=script&lang=js&"
export * from "./role_edit.vue?vue&type=script&lang=js&"
import style0 from "./role_edit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports